import React, { useEffect, useState } from 'react';

const NotificationBadge = ({ count }) => {
  const [fontSizeClass, setFontSizeClass] = useState('');

  useEffect(() => {
    const countLength = count?.toString()?.length;

    if (countLength >= 4) {
      setFontSizeClass('large');
    }

    if (countLength >= 5) {
      setFontSizeClass('extra-large');
    }
  }, [count]);

  return (
    <div className="notification-badge">
      <span className={`notification-count ${fontSizeClass}`}>{count}</span>
    </div>
  );
};

export default NotificationBadge;